import axios from 'axios';
import get from 'lodash/get';
import { TOKEN_REFRESH_URL } from '../api/urls';

import { BASE_API_URL } from './app-constants';
// import { ErrorSubject } from 'shared/ErrorSubject';
// import Auth from 'shared/Auth';

const instance = axios.create({
  baseURL: BASE_API_URL
});

/**
 * Intercept every request and append the authorization header
 */
instance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('access_token');

    if (token) {
      config.headers.common['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

/**
 * Intercept every response to see if the token has expired and requires a refresh
 */
instance.interceptors.response.use(
  response => {
    return response;
  },
  async err => {
    if (err.response) {
      // Access Token was expired
      if (err.response.status === 401) {
        try {
          const rs = await instance.post(`${TOKEN_REFRESH_URL}`);
          const { access_token } = rs.data;
          localStorage.setItem('access_token', JSON.stringify(access_token));

          return;
        } catch (error) {
          return Promise.reject(error);
        }
      }

      if (err.response.status === 403 && err.response.data) {
        return Promise.reject(err.response.data);
      }
    }

    return Promise.reject(err);
  }
);

export default instance;
